import resolve from "ioc/resolve";

function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item);
}

export function move(array, from, to) {
  array.splice(to, 0, array.splice(from, 1)[0]);
}

export function mergeDeep(target, source) {
  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }
  return target;
}

export function urlExists(url) {
  return url ? resolve("$http").head(url) : resolve("$q").reject(url);
}

export function imgExists(url) {
  let deferred = resolve("$q").defer();
  if (!url) {
    deferred.reject(url);
  } else {
    let img = new Image();
    img.onerror = () => deferred.reject(url);
    img.onload = () => deferred.resolve(url);
    img.src = url;
  }
  return deferred.promise;
}

export function chunk(arr, size) {
  var newArr = [];
  if (arr && arr.length) {
    for (var i = 0; i < arr.length; i += size) {
      newArr.push(arr.slice(i, i + size));
    }
  }
  return newArr;
}

export function splitOnFirst(s, c) {
  if (!s) return [s];
  var pos = s.indexOf(c);
  return pos >= 0 ? [s.substring(0, pos), s.substring(pos + 1)] : [s];
}

export function splitOnLast(s, c) {
  if (!s) return [s];
  var pos = s.lastIndexOf(c);
  return pos >= 0 ? [s.substring(0, pos), s.substring(pos + 1)] : [s];
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function pad(str, length) {
  while (str.length < length) {
    str = "0" + str;
  }
  return str;
}

export function deserializeQueryString(queryString) {
  var result = {},
    match,
    pl = /\+/g, // Regex for replacing addition symbol with a space
    search = /([^&=]+)=?([^&]*)/g,
    decode = function (s) {
      return decodeURIComponent(s.replace(pl, " "));
    },
    query = queryString.substring(
      queryString.indexOf("?") + 1,
      queryString.length
    );
  result.$$query = query;
  while ((match = search.exec(query)))
    result[decode(match[1])] = decode(match[2]);
  return result;
}

export function serializeQueryString(obj) {
  return Object.keys(obj)
    .filter((key) => (Array.isArray(obj[key]) ? obj[key].length : !!obj[key]))
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
    .join("&");
}

export function getRandom(max) {
  return Math.random() * max;
}

export function uuid() {
  var id = "",
    i;

  for (i = 0; i < 36; i++) {
    if (i === 14) {
      id += "4";
    } else if (i === 19) {
      id += "89ab".charAt(getRandom(4));
    } else if (i === 8 || i === 13 || i === 18 || i === 23) {
      id += "-";
    } else {
      id += "0123456789abcdef".charAt(getRandom(16));
    }
  }
  return id;
}

export function validateEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function convertToCSV(objArray) {
  var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  var str = "";
  for (var i = 0; i < array.length; i++) {
    var line = "";
    for (var index in array[i]) {
      if (line != "") line += ",";
      line += array[i][index];
    }
    str += line + "\r\n";
  }
  return str;
}
export function spawnUrl(url, { target, fileName } = {}) {
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.style.visibility = "hidden";
  if (target) {
    link.setAttribute("target", target);
  }
  if (link.download !== undefined && fileName) {
    link.setAttribute("download", fileName);
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
export function exportCSVFile(headers, items, fileTitle) {
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  var jsonObject = JSON.stringify(items);

  var csv = convertToCSV(jsonObject);

  var fileName = fileTitle + ".csv" || "export.csv";

  var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, fileName);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      spawnUrl(url, { fileName });
    }
  }
}

export function replaceSpaces(text) {
  return text.replace(/ /g, "-").toLowerCase();
}

export default {
  chunk,
  capitalize,
  replaceSpaces,
  pad,
  splitOnFirst,
  splitOnLast,
  deserializeQueryString,
  getRandom,
  uuid,
  validateEmail,
  urlExists,
  imgExists,
  mergeDeep,
  isObject,
  move,
  convertToCSV,
  exportCSVFile,
  spawnUrl,
};
